export default __webpack_public_path__ + "static/media/sETHo.61d3a76c.svg";